module.exports = {
  eventId: 'wKtURy66ieJcNLDilp3g',
  accountId: 'rqPbvpK7wEHmEQ8QuyqS',
  stages: ['0aaMiLvEuZdci6CUNIyO', '6TjZJihHfLCiA8Xa3lXj'],
  activateCertificate: '05 09 2021 16:00',
  liveEventId: 'ae856a2e-0bb4-47b2-9840-bd33031d9ba6',
};
